import { alpha, makeStyles } from "@material-ui/core/styles";
import { Colors } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({
  popoverpages: {
    marginLeft: "3rem",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "0",
    },
    "& .MuiPopover-paper": {
      border: `border: Mixed solid rgba(17, 48, 45, 0.08)`,
      boxShadow: `0px 4px 32.5px 0px rgba(9, 38, 35, 0.2)`,
      marginTop: "24px",
     
    },
    "& .popover-box": {
      position: "relative",
      zIndex: "1",
    },
    "& .popover-explain-text": {
      fontFamily: "Poppons sans-serif",
      fontSize: "14px",
      marginTop: "10px",
      maxWidth: "300px",
      lineHeight: "1.5",
      zIndex: "1",
    },
    "& .triangle-icon": {
      position: "absolute",
      right: "38px",
      top: "-16px",
      zIndex: "1",
    },
    "& .box-border-main": {
      border: `1px solid ${alpha(Colors.black, 0.1)}`,
      borderRadius: "8px",
    },
    "& .chip-btn": {
      width: "100%",
     
    },
    "& .MuiButton-label": {
      fontSize: theme.typography.subtitle1.fontSize,
    },
    "& .img-icon": {
      // project header
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0),
    },

    "& .body-color": {
      color: Colors.darkSlate,
    },
    // notification popover
    "& .notification-box": {
      position: "relative",
      width: "360px",
   
      border: `1px solid ${alpha(Colors.black, 0.1)}`,

      borderRadius: "8px",
      marginRight: "14px",
      "&:before": {
        content: " ",
        display: "inline",
        position: "absolute",
        top: "24px",
        left: "0px",
        bottom: 0,
        background: Colors.green,
        width: "8px",
        height: "8px",
        borderRadius: "50%",
      },
    },
    "& .notification-scroll": {
      maxHeight: "300px",
      overflowY: "scroll",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-track": {},
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        background: "#ECF0F3 ",
      },
    },
    "& .online-status": {
      position: "absolute",
      width: "8px",
      height: "8px",
      borderRadius: "4px",
      background: Colors.green,
      top: "-3px",
      left: "-1px",
      zIndex: "1000",
    },
    "& .max-width": {
      width: "60%",
      position: "relative",
    },
    "& .user-logout": {
      position: "absolute",
      right: theme.spacing(5),
    },
  },
  tutorialResources: {
    display: "flex", 
    alignItems: "center",
    padding: "0.5rem",
    '&:hover': {
        cursor: "pointer",
        backgroundColor: Colors.greenLight, // Example background change on hover
        color: Colors.white,           // Example text color change on hover
    }
  },
  buyMenu:{
    "& .MuiPopover-paper": {
      boxShadow: `0px 4px 32.5px 0px rgba(9, 38, 35, 0.2)`,
      marginTop: "0.5rem",
      marginLeft:"-3rem",
      [theme.breakpoints.down("sm")]: {
        marginLeft:"-0.5rem",
      },
     
    },
  },
  walletDetailsPopoverValue: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: "16.8px",
    letterSpacing: "-3%",
    padding:"1.25rem 1.25rem 0.25rem 1.25rem",
    
  },
  walletDetailsPopoverLabel:{
    color: "rgba(107, 130, 153, 0.9)",
    fontSize: "0.75rem",
    paddingBottom:"1.25rem"
  },

  listRow:{
    display:"flex",
    width:"100%",
    justifyContent:"space-between",
    alignItems:"center",
    textDecoration:"none",
    padding:"0.75rem 0.5rem",
    cursor:"pointer",
    "&:hover":{
      textDecoration:"none !important",
    }
  },

  listRowHover:{
    "& img ":{
      "&:hover":{
      color:"#11302D"
      }
     },
    width:"100%",
    alignItems:"center",
    display:"flex",
   "&:hover":{
    transition: "all 0.3s ease",
    backgroundColor: "rgba(107, 153, 153, 0.1)",
    borderRadius: "5px",
    cursor: "pointer",
    "& svg":{
      '& path':{
      stroke:"#11302D"
      }
   }
  },
},

  listTitle: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: "16.8px",
  },

  profileDivider:{
    width:"calc(100% + 1.5rem)", 
    marginLeft:"-0.75rem", 
    backgroundColor:"rgba(107, 153, 153, 0.1)", 
    height:"4px"
  },
  smallProfileDivider:{
    width:"calc(100% + 2.5rem)", 
    marginLeft:"-1.25rem", 
    backgroundColor:"rgba(17, 48, 45, 0.08)", 
    height:"1px"
  },

  profileUsername:{
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: "19.2px",
    marginTop:"0.625rem",
  },

  tierLevel:{
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: "14.4px",
    color:"rgba(107, 130, 153, 0.8)",
    marginTop:"0.2rem",
  },

  profileProgressBar:{
    "& .MuiLinearProgress-barColorPrimary":{
      backgroundColor:"#3EB8AA"
    },
    color:"#3EB8AA",
    backgroundColor:"rgba(17, 48, 45, 0.08)",
    height: 6,
    marginBottom: "0.5rem"
  },

  explainPopover: {
    backgroundColor: "#00000050",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0px",
    },
    "& .triangle-icon": {
      position: "absolute",
      right: "38px",
      top: "-16px",
      zIndex: "1",
    },
    "& .MuiPopover-paper": {
      border: `1px solid #11302D1A`,
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.05)}`,
      marginTop: "15px",
      [theme.breakpoints.down("xs")]: {
        boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.1)}`,
      },
    },
    "& .popover-box": {
      position: "relative",
      zIndex: "1",
    },
    "& .popover-explain-text": {
      color: "#11302D",
      fontSize: "14px",
      marginTop: "10px",
      maxWidth: "300px",
      [theme.breakpoints.down("xs")]: {
        maxWidth: "250px",
      },
      lineHeight: "1.5",
      zIndex: "1",
    },
    "& .box-border-main": {
      border: `1px solid ${alpha(Colors.black, 0.1)}`,
      borderRadius: "8px",
    },
    "& .chip-btn": {
      width: "100%",
    },
    "& .MuiButton-label": {
      fontSize: theme.typography.subtitle1.fontSize,
    },
    "& .body-color": {
      color: Colors.darkSlate,
    },
  },
  tutorialsPopover: {
   "& .MuiPopover-paper": {
     backgroundColor:"rgba(255, 255, 255, 0.95)",
     backdropFilter: "blur(2rem)",
     marginTop:"1.5rem",
     height:"auto",
     boxShadow: `0px 4px 32.5px 0px rgba(9, 38, 35, 0.2)`,
     borderRadius:"0.75rem",
     border: "1px solid rgba(17, 48, 45, 0.08)",
     overflowY: "auto",
    "& h2": {
      color:Colors.black,
      fontSize: "0.875rem",
      fontWeight: 700,
      margin:0,
      padding:0,
      marginBottom:"1rem",
      lineHeight:"1.05rem",
    },
  }
  },

  tutorialCard: {
    padding:"0.5rem",
    display:"flex",
    flexDirection:"column",
    borderRadius:"0.5rem",
    border: "1px solid rgba(17, 48, 45, 0.08)",
    transition: "transform 0.3s ease, border 0.3s ease",
    willChange: "transform",
    maxWidth:"100%",
    "& img":{
      width:"100%",
      height:"auto",
      borderRadius:".5rem"
    },
    "& .play-icon": {
      position: "absolute", 
      width:"1.875rem",
      height:"1.875rem",
      top: "50%", 
      left: "50%",
      transform: "translate(-50%, -50%)", 
      background: "rgba(0, 0, 0, 0.5)",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& h3": {
      color:Colors.black,
      fontSize: "0.875rem",
      fontWeight: 700,
      margin:0,
      padding:0,
      marginTop:"0.5rem",
      marginBottom:0,
      lineHeight:"1.05rem",
    },
    "& .MuiTypography-body1": {
      color:Colors.greySlate,
      fontSize: "0.75rem",
      fontWeight: 400,
    },
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.02)",
      border: "1px solid #3EB8AA",
    }
    },
}));

export default useStyles;
